export const card = () => ({
    height: 496,
    gridTemplateColumns: '64px 1fr 63px',
});

export const cardExtend = {
    card,
};
